import { parameters, DOMAIN, PROD_CUSTOM_DOMAIN } from '../../../back-end/deploy/environments';

/**
 * Variables to configure an ITER IDEA's cloud app, together with its inner modules.
 */
export const environment = {
  /** Enable after deploying the live-update backend; keep production opt-in. */
  eventLiveEnabled: false,
  idea: {
    project: 'jupiter',
    app: {
      version: '2.5.0',
      url: PROD_CUSTOM_DOMAIN ?? DOMAIN,
      mediaUrl: 'https://'.concat(parameters.mediaDomain),
      appleStoreURL: '',
      googleStoreURL: ''
    },
    api: {
      url: `${parameters.apiDomain}`,
      stage: 'dev'
    },
    auth: {
      title: 'Jupiter',
      registrationIsPossible: true,
      singleSimultaneousSession: false,
      forceLoginWithMFA: false,
      passwordPolicy: {
        minLength: 8,
        requireLowercase: false,
        requireDigits: false,
        requireSymbols: false,
        requireUppercase: false
      }
    },
    ionicExtraModules: ['common']
  },
  aws: {
    cognito: {
      userPoolId: 'eu-south-1_IaXXDOnkQ', //to be set accordingly on first deploy
      userPoolClientId: '60vgttces82mnq212ikmfdprvq' //to be set accordingly on first deploy
    }
  }
};
